import createIsValid from './isValid';

var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = createIsValid(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

export default createIsInvalid;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/selectors/isInvalid.js
// module id = 1246
// module chunks = 4